import { HistoryStackEntry } from "../types/HistoryStackEntry";
import { NavigationEventType } from "../types/NavigationEventType";
import { PageEnterDetail } from "../types/PageEnterDetail";

interface ProcessReloadArgs {
  currentUrl: string;
  emitEvent: (type: NavigationEventType, detail?: PageEnterDetail) => void;
  fscriptId: string;
  HistoryIndexKey: string;
  historyStack: HistoryStackEntry[];
  HistoryStackKey: string;
  lastKnownIndex: number;
  fscriptSessionId: string;
}

export const processReload = ({
  currentUrl,
  emitEvent,
  fscriptId: _fscriptId,
  HistoryIndexKey,
  historyStack,
  HistoryStackKey,
  lastKnownIndex,
  fscriptSessionId,
}: ProcessReloadArgs) => {
  const fscriptId = _fscriptId || history.state.fscriptId;
  let newCurrentIndex = lastKnownIndex;

  let emitReloadWithLostHistory = false;

  if (newCurrentIndex >= 0 && newCurrentIndex < historyStack.length) {
    historyStack[newCurrentIndex].fscriptId = fscriptId;
  } else {
    emitReloadWithLostHistory = true;

    historyStack = [
      {
        url: currentUrl,
        fscriptId: fscriptId,
      },
    ];

    newCurrentIndex = 0;
  }

  localStorage.setItem(
    HistoryStackKey + fscriptSessionId,
    JSON.stringify(historyStack)
  );
  localStorage.setItem(
    HistoryIndexKey + fscriptSessionId,
    newCurrentIndex.toString()
  );

  if (emitReloadWithLostHistory) {
    emitEvent("page_load", "reload_with_lost_history");
  }

  emitEvent("page_reload");
};
